import { inputs } from "../../../../../components/inputs/inputConfigs";

export default {
  groups: [
    {
      items: [
        {
          input: inputs.discountPercent,
          grid: { xs: 6 },
        },
        {
          input: inputs.comments,
          grid: { xs: 12 },
        },
      ],
    },
  ],
};
